<template>
  <div ref="masonryGrid" class="masonry-grid" :id="selector">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import Macy from 'macy'
import { debounce } from 'lodash'

export default defineComponent({
  name: 'UeMasonry',
  // this props will be passed to the macy library
  // to get the full list of options, see: https://github.com/bigbite/macy.js?tab=readme-ov-file#options
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    selector: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      masonry: null,
      observer: null,
    }
  },
  mounted() {
    this.initMasonry()
    this.setupResizeObserver()
  },
  methods: {
    initMasonry() {
      // Initialize the masonry grid
      this.masonry = Macy({
        container: this.selector ? `#${this.selector}` : '.masonry-grid',
        ...this.options,
      })
    },
    setupResizeObserver() {
      // Setup the resize observer to detect changes in the grid size
      this.observer = new ResizeObserver(() => {
        // Debounce the recalculation of the masonry grid to prevent excessive re-renders
        debounce(() => {
          this.masonry && this.masonry.recalculate(true)
        }, 100)()
      })

      // Observe the masonry grid
      this.observer.observe(this.$refs.masonryGrid)
    },
    recalculate() {
      // Public method to trigger masonry recalculation
      if (this.masonry) {
        this.masonry.recalculate(true)
      }
    },
  },
  updated() {
    // Recalculate the masonry grid when the component is updated
    debounce(() => {
      this.masonry && this.masonry.recalculate(true)
    }, 100)()
  },
  beforeDestroy() {
    // Remove the masonry grid
    if (this.masonry) {
      this.masonry.remove()
      this.masonry = null
    }

    // Remove the resize observer
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
})
</script>
